module.exports = __webpack_public_path__ + "static/media/logo_keiron.ae28999b.png";